function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["className", "description", "descriptionProps", "disabled", "heading", "headingProps", "icon", "iconProps", "loaderLabel", "loaderProps", "loading"];
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { forwardRef } from 'react';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import { ButtonVariants } from "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import { LoaderLooks, LoaderSizes } from "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import { FontIcon } from "../../icon/font-icon/font-icon.js";
import { CircleLoader } from "../../loader/circle-loader/circle-loader.js";
import "../../loader/shimmer-loader/shimmer-loader.js";
import { BaseButton } from "../base-button/base-button.js";
import classes from "./styles/tile-button.module.scss.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var TileButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var _classnames, _classnames3, _classnames4, _classnames5;
  var className = props.className,
    description = props.description,
    descriptionProps = props.descriptionProps,
    disabled = props.disabled,
    heading = props.heading,
    headingProps = props.headingProps,
    icon = props.icon,
    iconProps = props.iconProps,
    loaderLabel = props.loaderLabel,
    loaderProps = props.loaderProps,
    loading = props.loading,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(BaseButton, _extends({}, otherProps, {
    className: classnames((_classnames = {
      'bf-button__tile--disabled': disabled,
      'bf-button__tile--has-description': !!description,
      'bf-button__tile--has-icon': !!icon,
      'bf-button__tile--loading': loading
    }, _defineProperty(_classnames, classes['tile-button'], true), _defineProperty(_classnames, classes['tile-button--loading'], loading), _defineProperty(_classnames, "".concat(className), className), _classnames)),
    ref: ref,
    variant: ButtonVariants.Tile
  }), loading && loaderLabel ? /*#__PURE__*/React.createElement(CircleLoader, _extends({
    label: loaderLabel,
    look: LoaderLooks.Primary,
    size: LoaderSizes.Small
  }, loaderProps, {
    className: classnames(_defineProperty({
      'bf-button__tile-icon__loader': true
    }, "".concat(loaderProps === null || loaderProps === void 0 ? void 0 : loaderProps.className), !!(loaderProps !== null && loaderProps !== void 0 && loaderProps.className)))
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, icon && /*#__PURE__*/React.createElement(FontIcon, _extends({}, iconProps, {
    "aria-hidden": true,
    className: classnames((_classnames3 = {
      'bf-button__tile-icon': true
    }, _defineProperty(_classnames3, classes['tile-button__icon'], true), _defineProperty(_classnames3, "".concat(iconProps === null || iconProps === void 0 ? void 0 : iconProps.className), iconProps === null || iconProps === void 0 ? void 0 : iconProps.className), _classnames3)),
    icon: icon
  })), /*#__PURE__*/React.createElement("strong", _extends({}, headingProps, {
    className: classnames((_classnames4 = {
      'bf-button__tile-heading': true
    }, _defineProperty(_classnames4, classes['tile-button__heading'], true), _defineProperty(_classnames4, "".concat(headingProps === null || headingProps === void 0 ? void 0 : headingProps.className), headingProps === null || headingProps === void 0 ? void 0 : headingProps.className), _classnames4))
  }), heading), description && /*#__PURE__*/React.createElement("small", _extends({}, descriptionProps, {
    className: classnames((_classnames5 = {
      'bf-button__tile-description': true
    }, _defineProperty(_classnames5, classes['tile-button__description'], true), _defineProperty(_classnames5, "".concat(descriptionProps === null || descriptionProps === void 0 ? void 0 : descriptionProps.className), descriptionProps === null || descriptionProps === void 0 ? void 0 : descriptionProps.className), _classnames5))
  }), description)));
});
export { TileButton };